import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-close.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessClose';

class AgentBookingMailInprocessCloseCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessClose implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessCloseCtrl];
}

export default MODULE_NAME;
